import Loadable from '@/components/Loadable'
import { FunctionComponent, lazy } from 'react'

import { Route, Switch, Redirect } from 'react-router-dom'

const CpfRegistration = Loadable(lazy(() => import('@/pages/CpfRegistration')))

const CpfRegisteredBefore = Loadable(
  lazy(() => import('@/pages/CpfRegisteredBefore')),
)

const BirthDate = Loadable(lazy(() => import('@/pages/BirthDate')))

const UserData = Loadable(lazy(() => import('@/pages/UserData')))

const SendValidation = Loadable(lazy(() => import('@/pages/SendValidation')))

const CodeConfirmation = Loadable(
  lazy(() => import('@/pages/CodeConfirmation')),
)

const CreatePassword = Loadable(lazy(() => import('@/pages/CreatePassword')))

const AccountActivated = Loadable(
  lazy(() => import('@/pages/AccountActivated')),
)

const ClinicSelection = Loadable(lazy(() => import('@/pages/ClinicSelection')))

const DependentData = Loadable(lazy(() => import('@/pages/DependentData')))
const PasswordChangingForm = Loadable(
  lazy(() => import('@/pages/PasswordChangingForm')),
)
const PasswordChangingSuccess = Loadable(
  lazy(() => import('@/pages/PasswordChangingSuccess')),
)
const Support = Loadable(lazy(() => import('@/pages/Support')))

const Router: FunctionComponent = props => {
  return (
    <Switch {...props}>
      <Route
        exact
        path={[
          '/',
          '/verificar-cpf',
          '/direcionado-clinica/:idClinic/:uniqueCode',
          '/passo1',
          '/passo1/:uniqueCode',
          '/passo1/:idClinic/:uniqueCode/',
        ]}
        component={CpfRegistration}
      />
      <Route
        exact
        path={[
          '/cadastro/:cpfFromRegister',
          '/cadastro/:uniqueCode/:cpfFromRegister',
          '/cadastro/:idClinic/:uniqueCode/:cpfFromRegister',
        ]}
        component={CpfRegisteredBefore}
      />
      <Route exact path="/selecionar-clinica" component={ClinicSelection} />
      <Route exact path="/data-nascimento" component={BirthDate} />
      <Route exact path="/dados-usuario" component={UserData} />
      <Route exact path="/enviar-codigo" component={SendValidation} />
      <Route exact path="/confirmar-codigo" component={CodeConfirmation} />
      <Route exact path="/criar-senha" component={CreatePassword} />
      <Route exact path="/conta-ativada" component={AccountActivated} />
      <Route
        exact
        path="/dados-dependente/:dependentId"
        component={DependentData}
      />
      <Route
        exact
        path={[
          '/alterar-senha',
          '/alterar-senha/form',
          '/alterar-senha/load',
          '/alterar-senha/load/:uniqueCode/:token',
          '/alterar-senha/load/:token',
        ]}
        component={PasswordChangingForm}
      />
      <Route
        exact
        path={'/senha-alterada'}
        component={PasswordChangingSuccess}
      />
      <Route
        exact
        path={['/suporte', '/suporte/:uniqueCode']}
        component={Support}
      />
      <Redirect to="/" />
    </Switch>
  )
}

export default Router
